/**
 * Navigation History Manager
 * مدیریت history stack برای کنترل back navigation
 */

/**
 * پاک کردن history stack و جایگزینی با یک entry جدید
 * این تابع برای زمانی است که میخواهیم کاربر نتواند به صفحات قبلی برگردد
 */
export const clearHistoryStack = (newPath: string = '/dashboard') => {
  // فقط جایگزینی history بدون اضافه کردن entry جدید
  window.history.replaceState(null, '', newPath);
  
  console.log('🗑️ [NavigationHistory] History stack cleared, new path:', newPath);
};

/**
 * بلاک کردن back navigation به صفحات خاص
 * این تابع یک event listener اضافه می‌کند که back navigation را مسدود می‌کند
 */
export const blockBackNavigation = (onBackAttempt?: () => void) => {
  // Push current state to prevent going back
  window.history.pushState(null, '', window.location.href);

  const handlePopState = (e: PopStateEvent) => {
    // Prevent default back behavior
    e.preventDefault();
    
    // Push current state again to block back navigation
    window.history.pushState(null, '', window.location.href);
    
    // Call optional callback
    if (onBackAttempt) {
      onBackAttempt();
    }
    
    console.log('🚫 [NavigationHistory] Back navigation blocked');
  };

  window.addEventListener('popstate', handlePopState);

  // Return cleanup function
  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
};

/**
 * جایگزینی صفحه فعلی در history بدون اضافه کردن entry جدید
 * برای navigation که نمیخواهیم کاربر بتواند به آن برگردد
 */
export const replaceCurrentPage = (path: string) => {
  window.history.replaceState(null, '', path);
  console.log('🔄 [NavigationHistory] Current page replaced with:', path);
};
